import { Nullable } from "@core/domain/types/nullable.type";
import { BudgetRepository } from "@project/data/repositories/budget.repository";
import { BudgetValidation } from "@project/domain/models/budget/financial-entity-budget.model";
import { inject, injectable } from "inversify";

@injectable()
export class EditBudgetValidationUseCase {
    constructor(
        @inject(BudgetRepository)
        private readonly budgetRepository: BudgetRepository,
    ) {}

    async execute(
        validation: BudgetValidation,
    ): Promise<Nullable<BudgetValidation>> {
        const budgetValidationsResult =
            await this.budgetRepository.editValidation(validation);

        return budgetValidationsResult.fold(
            () => null,
            (budgetValidation) => budgetValidation,
        );
    }
}
